import React, { useState } from "react";
import "./Calendar.css"; // Импортируйте стили для вашего календаря
import dayjs, { Dayjs } from "dayjs";

interface Event {
  date: Date;
  title: string;
}

interface CalendarProps {
  events: any[];
}

const MONTHS: any = {
  1: "Январь",
  2: "Февраль",
  3: "Март",
  4: "Апрель",
  5: "Май",
  6: "Июнь",
  7: "Июль",
  8: "Август",
  9: "Сентябрь",
  10: "Октябрь",
  11: "Ноябрь",
  12: "Декабрь",
};

interface Event {
  date: Date;
  description: string;
}

interface CalendarProps {
  events: any[];
}

export const Calendar: React.FC<CalendarProps> = ({ events }) => {
  const [currentMonth, setCurrentMonth] = useState(dayjs());

  const year = currentMonth.get("year");
  const month = currentMonth.get("month") + 1;

  const changeMonth = (dif: number) => {
    setCurrentMonth(currentMonth.add(dif, "month"));
  };

  const daysInMonth = currentMonth.daysInMonth();

  const firstDayOfMonth = currentMonth.startOf("month");
  const lastDayOfMonth = currentMonth.endOf("month");

  const startDayIndex = (firstDayOfMonth.get("day") + 6) % 7;
  console.log("🚀 ~ startDayIndex:", startDayIndex);

  const calendarDays = [];
  for (let i = 0; i < startDayIndex; i++) {
    calendarDays.push(<td key={`empty-start-${i}`} className="empty-cell"></td>);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const currentDay = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
    const eventExists = events.filter((event) => {
      return event.date === currentDay;
    });

    calendarDays.push(
      <td key={day} className={eventExists.length > 0 ? "event-cell" : ""}>
        <div>{day}</div>
        {eventExists.length > 0 && <div className="event-cell-count">{eventExists.length}</div>}
      </td>
    );
  }

  const endDayIndex = lastDayOfMonth.get("day");
  const emptyCellsAfter = 7 - endDayIndex;
  for (let i = 0; i < emptyCellsAfter; i++) {
    calendarDays.push(<td key={`empty-end-${i}`} className="empty-cell"></td>);
  }

  const weeks = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    weeks.push(<tr key={i}>{calendarDays.slice(i, i + 7)}</tr>);
  }

  return (
    <>
      <div className="calendar_months">
        <span onClick={() => changeMonth(-1)} className="calendar_months_btn">{`<`}</span>
        <span>{MONTHS[month]}</span>
        <span onClick={() => changeMonth(1)} className="calendar_months_btn">{`>`}</span>
      </div>
      <div className="calendar">
        <table>
          <thead>
            <tr>
              <th>Пн</th>
              <th>Вт</th>
              <th>Ср</th>
              <th>Чт</th>
              <th>Пт</th>
              <th>Сб</th>
              <th>Вс</th>
            </tr>
          </thead>
          <tbody>{weeks}</tbody>
        </table>
      </div>
    </>
  );
};
